import './Home.css';

import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, useParams } from "react-router-dom";

import FPO_HOME from './Homepage_Fullscreen_2x.png';

import { postWithAuth } from '../../utils/api';
import handleVisit from '../../utils/handleVisit';
import useSession from '../../hooks/useSession';
import FPOImage from '../../components/FPOImage';

const FPO_OUTLINE = false;

export default function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const { landingKey } = useParams();
  const { session, setSession } = useSession();

  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');

  // ⬇️ On first render, if a token exists, go to /stats
  useEffect(() => {
    const handleSession = async () => {
      if (!session) {
        return;
      }

      // if coming from /play, return to /play
      if (location.search) {
        const urlParams = new URLSearchParams(location.search);
        const claimKey = urlParams.get('claim');
        const stationId = urlParams.get('station');
        
        if (claimKey && stationId) {
          return navigate(`/play${location.search}`, { replace: true });
        }
      }

      // otherwise, handle visit and go to /stats, using optional landingKey
      await handleVisit(landingKey, session);
      return navigate("/stats", { replace: true });
    }

    handleSession();
  }, [navigate, session, location.search, landingKey]);

  const submitUser = async () => {
    try {
      const res = await postWithAuth('/users', null, {
        email: String(email),
        username: String(username)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data?.message || 'Request failed');

      const t = data.token || '';
      const i = data.user.id || '';
      const d = data.user.username || '';
      setSession({ authToken: t, id: i, display: d });
      console.log('Your token:', t);
      console.log('Your id:', i);
    } catch (err) {
      console.error('Error:', err);
    }
  };
  return (
    <div className="page">
      <FPOImage src={FPO_HOME} height={800} offset={0} isOutlined={FPO_OUTLINE} />
      <form
        className="login"
        onSubmit={(e) => {
          e.preventDefault();
          submitUser();
        }}
      >
        <label className="label" htmlFor="username">Username</label>
        <input
          className="input"
          id="username"
          maxLength="12"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Enter username"
          autoComplete="username"
        />
        <label className="label" htmlFor="email">Email</label>
        <input
          className="input"
          id="email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="Enter email"
          autoComplete="email"
        />
        <button type="submit">Let's Play</button>
      </form>
      <FPOImage src={FPO_HOME} height={380} offset={-950} isOutlined={FPO_OUTLINE} />
    </div>
  );
}